
import { useTranslation } from 'react-i18next';

export default function ServicesSection() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-calendar-check-line',
      title: t('management.services.items.0.title'),
      description: t('management.services.items.0.description'),
      features: [
        t('management.services.items.0.features.0'),
        t('management.services.items.0.features.1'),
        t('management.services.items.0.features.2')
      ],
      color: 'from-[#8b2500] to-[#6b1d00]'
    },
    {
      icon: 'ri-home-smile-line',
      title: t('management.services.items.1.title'),
      description: t('management.services.items.1.description'),
      features: [
        t('management.services.items.1.features.0'),
        t('management.services.items.1.features.1'),
        t('management.services.items.1.features.2')
      ],
      color: 'from-[#c9a84c] to-[#a88a3c]'
    },
    {
      icon: 'ri-line-chart-line',
      title: t('management.services.items.2.title'),
      description: t('management.services.items.2.description'),
      features: [
        t('management.services.items.2.features.0'),
        t('management.services.items.2.features.1'),
        t('management.services.items.2.features.2')
      ],
      color: 'from-[#2d5016] to-[#1d3810]'
    }
  ];

  return (
    <section className="relative py-20 bg-gradient-to-b from-stone-50 via-amber-50 to-stone-50 font-serif">
      {/* 上部装飾ライン - 市松模様 */}
      <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-transparent via-[#8b2500] to-transparent opacity-60"></div>
      <div className="absolute top-2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-50"></div>

      {/* 下部装飾ライン - 市松模様 */}
      <div className="absolute bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-50"></div>
      <div className="absolute bottom-0 left-0 right-0 h-2 bg-gradient-to-r from-transparent via-[#8b2500] to-transparent opacity-60"></div>

      <div className="max-w-7xl mx-auto px-6">
        {/* セクションタイトル */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-stone-800 mb-4">
            ◆ {t('management.services.title')} ◆
          </h2>
          
          {/* 金色装飾ライン */}
          <div className="flex items-center justify-center gap-3 mt-6">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-[#c9a84c]"></div>
            <span className="text-[#8b2500] text-xl">◇</span>
            <div className="h-px w-32 bg-[#c9a84c]"></div>
            <span className="text-[#8b2500] text-xl">◇</span>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-[#c9a84c]"></div>
          </div>

          <p className="text-stone-600 mt-6 max-w-2xl mx-auto leading-relaxed">
            {t('management.services.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-b from-stone-50 to-amber-50/50 rounded-lg overflow-hidden border-2 border-[#8b2500]/30 hover:border-[#8b2500]/50 transition-all duration-300 hover:shadow-xl"
            >
              {/* 四隅装飾 */}
              <div className="absolute top-2 left-2 w-5 h-5 border-t-2 border-l-2 border-[#8b2500] opacity-60 z-10"></div>
              <div className="absolute top-2 right-2 w-5 h-5 border-t-2 border-r-2 border-[#8b2500] opacity-60 z-10"></div>
              <div className="absolute bottom-2 left-2 w-5 h-5 border-b-2 border-l-2 border-[#8b2500] opacity-60 z-10"></div>
              <div className="absolute bottom-2 right-2 w-5 h-5 border-b-2 border-r-2 border-[#8b2500] opacity-60 z-10"></div>

              {/* カードヘッダー - 和風カラー */}
              <div className={`bg-gradient-to-r ${service.color} p-6 relative`}>
                {/* 金色装飾ライン */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#c9a84c] to-transparent opacity-80"></div>

                <div className="w-14 h-14 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full mb-4 mx-auto group-hover:scale-110 transition-transform duration-300">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-white text-center">
                  ◇ {service.title}
                </h3>
              </div>

              {/* カードコンテンツ */}
              <div className="p-6">
                <p className="text-stone-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                <ul className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <span className="text-[#8b2500] mt-1 flex-shrink-0">✦</span>
                      <span className="text-stone-700">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
